import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-coupon-search-form",
  templateUrl: "./coupon-search-form.component.html",
  styleUrls: ["./coupon-search-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CouponSearchFormComponent {
  @Input() loading: boolean;
  @Input() hasDetails: boolean;

  @Input() set scannedCode(value: string) {
    this.codeControl.setValue(value);
  }

  @Output() search = new EventEmitter<string>();
  @Output() scan = new EventEmitter<string>();

  form = new FormGroup({
    code: new FormControl(null, [Validators.required, Validators.minLength(5)])
  });

  get codeControl(): FormControl<string> {
    return this.form.controls.code as FormControl<string>;
  }

  onClick(): void {
    if (this.hasDetails) {
      this.codeControl.reset(null, { emitEvent: false });
      this.search.emit(this.codeControl.value);
    } else {
      this.onSearch();
    }
  }

  private onSearch(): void {
    if (this.form.valid) {
      this.search.emit(this.codeControl.value);
    }
  }
}
